import { render, staticRenderFns } from "./info.vue?vue&type=template&id=9b1662fe&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"
import style0 from "./info.vue?vue&type=style&index=0&id=9b1662fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1662fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b1662fe')) {
      api.createRecord('9b1662fe', component.options)
    } else {
      api.reload('9b1662fe', component.options)
    }
    module.hot.accept("./info.vue?vue&type=template&id=9b1662fe&scoped=true", function () {
      api.rerender('9b1662fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/deposit/components/info.vue"
export default component.exports